/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import './handlebars/helper-date';
import './handlebars/helper-i18n';
import './handlebars/helper-img';
import './handlebars/helper-markdown';
import './handlebars/helper-xsrfTokenInput';

export default Handlebars;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@okta/courage/src/util/handlebars-wrapper.js
// module id = 47
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/util/handlebars-wrapper.js